// extracted by mini-css-extract-plugin
export var body = "_dg-0";
export var sectionHeader = "_dg-4";
export var shortcutColumns = "_dg-2";
export var shortcutList = "_dg-1";
export var shortcutSection = "_dg-3";